module.exports = __webpack_public_path__ + "img/2-2-6.afa88885.png";